
// components
import { CompactPlaylist } from '../../compactPlaylist/CompactPlaylist'
import { PlaylistPanel } from '../../playlistPanel/PlaylistPanel'

// mui
import { Box, Stack } from '@mui/material';

interface Props {
    playlistName: string | null
}

export const MobileLandscapeView = ({playlistName}: Props) => {
    return (
        <Stack
            direction='row'
            spacing={3}
            width='98vw'
        >
            <Box sx={{
                width: '60%'
            }}>
                <CompactPlaylist mobileView={true} mobileViewOrientation='landscape' playlistName={playlistName} />
            </Box>
            <Box sx={{
                width: '40%'
            }}>
                <PlaylistPanel view='listMobile' mobileViewOrientation='landscape' playlistName={playlistName} />
            </Box>
        </Stack>
    )
}
